<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("vat_groups") }}</h4>
        </div>
      </div>
    </div>
    <p class="text-secondary small mb-3">{{ $t("vat_groups_managed_by_platform") }}</p>

    <ThemeDataTable
      ref="vatGroupTable"
      table-id="VatGroupTable"
      :fetch-data="fetchVatGroupsPage"
      :default-order-column="1"
      default-order-dir="asc"
    >
      <template #default="{ rows }">
        <thead class="thead-light">
          <tr>
            <th>{{ $t("vat_group_name") }}</th>
            <th>{{ $t("vat_value") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in rows" :key="group.id">
            <td>{{ group.vat_group_name }}</td>
            <td>{{ group.vat_value }}</td>
          </tr>
        </tbody>
      </template>
    </ThemeDataTable>
  </div>
</template>

<script>
import ThemeDataTable from '@/components/common/ThemeDataTable.vue';
import apiUrls from '@/urls';

export default {
  components: {
    ThemeDataTable,
  },
  methods: {
    async fetchVatGroupsPage({ draw, start, length, search, orderColumn, orderDir }) {
      const params = {
        draw,
        start,
        length,
        'search[value]': search || '',
        'order[0][column]': orderColumn,
        'order[0][dir]': orderDir,
      };

      const response = await this.$axios.get(apiUrls.vat_group.get, { params });
      const payload = response.data || {};

      return {
        data: payload.data || [],
        recordsTotal: payload.recordsTotal || 0,
        recordsFiltered: payload.recordsFiltered || 0,
      };
    },
  },
};
</script>
